export function getEntityIdPrefix(entityName: string): string {
  const fn = '[cynqueModules/getEntityIdPrefix] getEntityIdPrefix |'
  const entityNamePrefixes: Record<string, string> = {
    account: 'A',
    accountDocument: 'AD',
    accountNote: 'AN',
    case: 'CA',
    caseDocument: 'CAD',
    // CAN, not CN: CN belongs to CompanyNote. The prefix has to be unique, and
    // this one matches the server's own (__prefix__="CAN" on CaseNote).
    caseNote: 'CAN',
    // `caseReply` is an ACTION, not a collection -- it resolves to
    // POST /api/cases/{id}/replies. It is here because a CREATE dialog mints a
    // client-side id in mock mode (getNextEntityId) before it knows the write is
    // an action, and this registry throws on an unknown name. 'CAN' is historical
    // (a reply used to create a CaseNote; since cynque-api-server #1737 it
    // creates a case email) and harmless: the id is discarded, because both
    // the server and the mock handler mint their own.
    caseReply: 'CAN',
    caseType: 'CAT',
    call: 'CL',
    contact: 'CT',
    contactRole: 'CR',
    company: 'C',
    companyContact: 'CCT',
    companyContactRole: 'CCR',
    companyDocument: 'CD',
    companyMSDocument: 'CMSD',
    companyMSServiceDocument: 'CMSSD',
    companyLastSelectedState: 'CLSD',
    companyMasterService: 'CMS',
    companyMSService: 'CMSS',
    companyMSTeamMember: 'CMSTM',
    companyNote: 'CN',
    companyMSNote: 'CMSN',
    companyMSServiceNote: 'CMSSN',
    companyTeamMember: 'CTM',
    contract: 'CON',
    contractDocument: 'COND',
    contractNote: 'CONN',
    email: 'EM',
    feedback: 'F',
    fieldSet: 'FS',
    fieldSetField: 'FSF',
    group: 'G',
    industry: 'I',
    leadSourceCampaign: 'LSC',
    leadSourceContact: 'LSO',
    leadSourceEvent: 'LSE',
    location: 'L',
    locationCompanyContact: 'LCC',
    locationDocument: 'LD',
    locationHardwareCompanyOwnedItem: 'COH',
    locationHardwareTenantOwnedItem: 'TOH',
    locationNote: 'LN',
    locationType: 'LT',
    order: 'ORD',
    orderMasterService: 'ORDMS',
    orderMSService: 'ORDMSS',
    orderLastSelectedState: 'ORDLSD',
    orderContact: 'ORDC',
    orderMSContact: 'ORDMSC',
    orderTeamMember: 'ORDTM',
    orderMSTeamMember: 'ORDMSTM',
    orderServiceOrder: 'ORDSO',
    orderDocument: 'ORDD',
    orderMSDocument: 'ORDMSD',
    orderMSServiceDocument: 'ORDMSSD',
    orderNote: 'ORDN',
    orderMSNote: 'ORDMSN',
    orderMSServiceNote: 'ORDMSSN',
    meeting: 'M',
    opportunity: 'O',
    opportunityMasterService: 'OMS',
    opportunityMSService: 'OMSS',
    opportunityNote: 'ON',
    opportunityMSNote: 'OMSN',
    opportunityMSServiceNote: 'OMSSN',
    opportunityRegistration: 'OR',
    opportunityStage: 'OS',
    opportunityLastSelectedState: 'OLSD',
    opportunityContact: 'OC',
    opportunityMSContact: 'OMSC',
    opportunityTeamMember: 'OTM',
    opportunityMSTeamMember: 'OMSTM',
    opportunityDocument: 'OD',
    opportunityMSDocument: 'OMSD',
    opportunityMSServiceDocument: 'OMSSD',
    split: 'PO',
    person: 'PE',
    product: 'PR',
    productCategory: 'PRC',
    productGroup: 'PRG',
    productKitItem: 'PRKI',
    productSubcategory: 'PRSC',
    project: 'P',
    supplierQuote: 'SQ',
    supplierProduct: 'SP',
    supplierProductDocument: 'SPD',
    supplierProductItem: 'SPI',
    supplierProductNote: 'SPN',
    serviceRequest: 'SR',
    // Forked from the case* entries above (`cases-pre-sr-fork`). ⚠ Not 'SRE' for
    // anything: that is supplierResource's.
    serviceRequestDocument: 'SRD',
    serviceRequestNote: 'SRN',
    // An action, like caseReply: it mints the id of the note it creates.
    serviceRequestReply: 'SRN',
    serviceRequestType: 'SRT',
    subindustry: 'SI',
    supplier: 'S',
    supplierContact: 'SCT',
    supplierContactRole: 'SCR',
    supplierDocument: 'SD',
    supplierLastSelectedState: 'SLSD',
    supplierNote: 'SN',
    supplierResource: 'SRE',
    teamMember: 'TM',
    teamMemberLastSelectedState: 'TMLSD',
    task: 'TA',
    tsd: 'T',
    tsdContact: 'TCT',
    tsdDocument: 'TD',
    tsdContactRole: 'TCR',
    tsdLastSelectedState: 'TLSD',
    tsdNote: 'TN',
    tsdResource: 'TRE',
    tsdSupplier: 'TS',
    user: 'U',
  }

  if (!entityNamePrefixes.hasOwnProperty(entityName)) {
    throw new Error(
      `${fn} entityNamePrefixes object does not contain property '${entityName}'`
    )
  }

  return entityNamePrefixes[entityName]
}
